import { parseTemplate, transformOrigin } from "../util/helpers.js";
import { opts } from '../opts.js';

import { hits } from '../../../../dist/vendor/instantsearch.js/es/widgets/index.js';
// import { highlight } from '../../../../dist/vendor/instantsearch.js/es/helpers/components/Highlight.js';
const { cssClasses, imageSize } = opts.hits;



const terms = taxonomies => {
	const termset = taxonomies ? Object.keys(taxonomies)
		.map(tax => taxonomies[tax]) : [];

	let first = true;

	const pills = termset.map(terms => {
		return terms.map(term => {
			const name = term.name || term;
			const link = term.link || '';
			const pill = `
				<span class="pill ${first ? 'pill--content-type' : ''}">
					<a href="${link}">${name}</a>
				</span>`;
			first = false;
			return pill;
		}).join('');
	});

	return pills.join('');
}

// const image = ({
// 	images,
// 	post_title
// }) => {
// 	if (!images) {
// 		return '<img src="/wp-content/themes/ul/assets/img/emc-placeholder.png" alt="image placeholder">';
// 	}
// 	const src = images[imageSize]?.url;
// 	return src
// 		? `<img src="${transformOrigin(images[imageSize].url)}" alt="${post_title}"/>`
// 		: '<img src="/wp-content/themes/ul/assets/img/emc-placeholder.png" alt="image placeholder">';
// }


const searchPageResult = hit => parseTemplate('card', hit);
const transformHit = hit => {

	const { _highlightResult } = hit;
	_highlightResult &&Object.entries(_highlightResult).forEach(entry => {
		if (entry[1]?.value && hit[entry[0]]) {
			hit[entry[0]] = entry[1]?.value
		}
	})

	const permalink = transformOrigin(hit.permalink);

	const filename = permalink.replace(/^.*[\\/]/, '');

	return {
		...hit,
		post_title:  (hit.post_title === '�' )  ? filename : hit.post_title,
		permalink,
		// terms: terms(hit.taxonomies)  ?? '',
		// image: image(hit),
		terms: '',
	}
};

 export const config = {
	...opts.hits,
	templates: {
		item(item, { html, components, sendEvent }) {
			const transformed = transformHit(item);
			return searchPageResult(transformed);
		},
		empty(results, { html }) {
			return html`
			<div class="${cssClasses.noResults}">
				<h3>Uh oh... </h3>
				<p>No results for <q>${results.query}</q></p>
			</div>`;
		},
	},
};

export const widget = hits;
